import { useNavigationStack } from "@jwp/ott-common/src/stores/NavigationStackStore";
import { useNavigate } from 'react-router';

export const handleBackNavigate = (navigate: ReturnType<typeof useNavigate>) => {
  const params = new URLSearchParams(window.location.search);
  const returnPath = params.get('returnPath') || params.get('return_path');

  if (returnPath) {
    navigate(returnPath, { replace: true });
    return;
  }

  const previousRoute = useNavigationStack.getState().pop();
  const ancestorRoute = useNavigationStack.getState().ancestor;

  const sanitizePath = (path?: string) => {
    if (!path) return path;
    const url = new URL(path, window.location.origin);
    if (url.searchParams.has('play')) { 
      url.searchParams.delete('play');
    }
    return url.pathname + url.search;
  };

  const cleanedPrevious = previousRoute && sanitizePath(previousRoute);
  const cleanedAncestor = sanitizePath(ancestorRoute);

  if (cleanedPrevious) {
    navigate(cleanedPrevious, { replace: true });
  } else if (cleanedAncestor) {
    navigate(cleanedAncestor, { replace: true });
  } else {
    navigate('/', { replace: true });
  }
};


